/**
 * Shared styling for the sign-in card's forms (password and two-factor steps).
 */

import type { CSSProperties } from 'react';

export const AUTH_LABEL_CLASS = 'block mb-2 text-text text-[0.8125rem] font-medium';

export const AUTH_INPUT_CLASS =
  'w-full py-3 px-4 bg-surface border border-border rounded-lg text-text text-[0.9375rem] transition-all placeholder:text-text-muted focus:outline-none focus:border-primary focus:bg-[var(--table-row-hover-bg)] focus:shadow-[0_0_0_3px_var(--color-primary-tint-15)]';

export const AUTH_ERROR_CLASS =
  'py-3 px-4 mb-4 rounded-lg bg-[var(--color-danger-tint-20)] border border-[var(--color-danger-tint-30)] text-danger text-sm';

export const AUTH_SUBMIT_CLASS =
  'w-full mt-2 py-3.5 px-6 border-none rounded-lg text-white text-base font-semibold cursor-pointer transition-all shadow-[0_2px_8px_var(--color-primary-tint-30)] disabled:opacity-60 disabled:cursor-not-allowed hover:enabled:-translate-y-px hover:enabled:shadow-[0_4px_16px_var(--color-primary-tint-40)] active:enabled:translate-y-0';

export const AUTH_SUBMIT_STYLE: CSSProperties = {
  background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-accent) 100%)',
};

export const AUTH_SECONDARY_BUTTON_CLASS =
  'w-full py-3 px-6 rounded-lg border border-border bg-surface text-text text-[0.9375rem] font-medium cursor-pointer transition-all hover:enabled:border-primary disabled:opacity-60 disabled:cursor-not-allowed';

export const AUTH_HEADING_CLASS = 'text-lg font-semibold text-text m-0 mb-2';

export const AUTH_BODY_CLASS = 'text-sm text-text-muted m-0 mb-4';

export const AUTH_LINK_BUTTON_CLASS =
  'bg-transparent border-none p-0 text-sm text-text-muted underline cursor-pointer hover:text-text';

/** A small text link inside a form, e.g. "Forgot password?" beside a label. */
export const AUTH_INLINE_LINK_CLASS =
  'bg-transparent border-none p-0 text-[0.8125rem] text-primary cursor-pointer hover:underline';

export const AUTH_SUCCESS_CLASS =
  'py-3 px-4 mb-4 rounded-lg bg-[var(--color-primary-tint-15)] border border-[var(--color-primary-tint-30)] text-text text-sm';
